import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, booleanAttribute, input } from '@angular/core';
import type { Params } from '@angular/router';
import type { Icon } from '@hyundai/assets';
import { FootnotesPipe, RouterLinkDirective, TrackingDirective } from '@hyundai/ng-common-lib';

@Component({
    selector: 'ui-m040-c090-icon-text-card',
    standalone: true,
    templateUrl: './m040-c090-icon-text-card.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLinkDirective, NgClass, FootnotesPipe, TrackingDirective],
})
export class M040C090IconTextCardComponent {
    headline = input.required<string>();
    text = input.required<string>();
    icon = input<Icon>();
    link = input<string>();
    queryParams = input<Params | null>();
    linkQueryParams = input<Record<string, string>>();
    priceTags = input<Array<{ headline?: string; text: string }>>();
    isFirstView = input.required({ transform: booleanAttribute });
}
